import { GetCustomersParams } from "@/models/payload/customer";
import customerService from "@/services/customer";
import { useQuery } from "@tanstack/react-query";

type Props = {
  params: GetCustomersParams;
};

function useGetSearchCustomers({ params }: Props) {
  const { data, isLoading, refetch, isFetching } = useQuery(
    ["customersSearch", params.Term],
    () => customerService.getCustomers(params),
    {
      enabled: false,
    }
  );

  return { data, isLoading: isLoading && isFetching, refetch };
}

export default useGetSearchCustomers;
